import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const StatsSection = () => {
  const statsRef = useRef([]);

  const stats = [
    {
      value: 91,
      suffix: "k+",
      unit: "Metric Tons",
      label: "Annual Organic Fertilizer",
    },
    {
      value: 250,
      suffix: "+",
      unit: "Outlets",
      label: "Authorised Distributors",
    },
    {
      value: 3,
      suffix: "",
      unit: "States",
      label: "GJ | RJ | MH Covered Across India",
    },
  ];

  useEffect(() => {
    statsRef.current.forEach((el, index) => {
      const targetValue = stats[index].value;
      const countElement = el.querySelector(".count-number");

      gsap.fromTo(
        countElement,
        { innerText: 0 },
        {
          innerText: targetValue,
          duration: 2,
          snap: { innerText: 1 }, // Ensures whole numbers only
          scrollTrigger: {
            trigger: el,
            start: "top 85%", // Starts animation when 85% from top
          },
          onUpdate: function () {
            // Optional: formatting if needed, though snap handles basic integers
            countElement.innerHTML = Math.ceil(this.targets()[0].innerText);
          },
        },
      );
    });
  }, []);

  return (
    <section className="flex justify-center w-full py-10 md:py-20 px-4">
      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-10 w-full max-w-[1400px] justify-center items-center lg:items-stretch">
        {stats.map((stat, index) => (
          <div
            key={index}
            ref={(el) => (statsRef.current[index] = el)}
            className="flex flex-col items-center justify-center gap-4 
                       w-full max-w-[400px] lg:flex-1
                       bg-white border border-[#343163] 
                       rounded-[40px] md:rounded-[60px] lg:rounded-[80px] 2xl:rounded-[120px] 
                       p-6 md:p-12 lg:p-10 xl:p-16
                       transition-all hover:shadow-xl hover:-translate-y-2 duration-300"
          >
            <div className="flex flex-col items-center text-center">
              <span className="text-[48px] md:text-[64px] lg:text-[80px] xl:text-[90px] font-bold leading-none text-[#343163]">
                <span className="count-number">0</span>
                {stat.suffix}
              </span>
              <span className="text-[16px] md:text-[18px] lg:text-[20px] font-medium text-[#1b0e02] opacity-70 mt-2">
                {stat.unit}
              </span>
            </div>

            <div className="w-12 h-1 bg-[#343163] opacity-20 rounded-full"></div>

            <div className="text-[18px] md:text-[22px] lg:text-[28px] font-bold leading-tight text-center text-[#1b0e02]">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
